import { createSelector } from 'reselect';

const getNodesByParent = (state, props) => {
  return state.catalog.nodes.filter(
    n => n.parent && n.parent.toString() === props.node.id.toString()
  );
};

export const getNodeChildren = createSelector(getNodesByParent, nodes =>
  nodes.sortBy(n => n.order).toArray()
);



// WEBPACK FOOTER //
// ./src/modules/catalog/selectors/node.js